/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import styled from "@emotion/styled";
import RetrunFindCoupon from './ReturnFindCoupon';
import get_token from "../lib/get_token";
import ReturnEditDetail from "./ReturnEditDetail";
import get_gift from "../lib/get_gift";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Container = styled(Box)`
  padding: 10px;
`;

const CouponContainer = styled(Box)`
  display: flex;
  margin-top: 10px;
  align-items: center;
`;

// 등록하기 팝업
function ReturnEdit(props) {
  const { openEdit, setOpenEdit, login, load_data, seq } = props;
  const token = localStorage.getItem("token");
  const [openFindCoupon, setOpenFindCoupon] = useState(false); // 쿠폰찾기 팝업
  const title = '사은품신청';
  const [reason, setReason] = useState('');
  const [reason_etc, setReasonEtc] = useState('');
  const [return_coupon_count, setReturnCouponCount] = useState(0);
  const [data, setData] = useState({ // 1
    amount: '',
    state: '',
    gname: '',
    mname: '',
    pdate: '',
    regdate: '',
    opt: '',
  });
  const gift = get_gift();

  const onSubmit = async () => {
    let result = await axios.post(configState.api + '/gympass_admin/gift_edit', {
      mcd: login.mcd,
      cid: login.cid,
      level: login.level,
      seq: seq,
      state: data.state,
      pdate: data.pdate,
      amount: data.amount,
      opt: data.opt,
    });
    if (result.data.success !== 1) {
      Swal.fire('오류', result.data.msg);
    }
    setOpenEdit(false);
    load_data(); // 부모창 새로고침
  }

  const load_data1 = async () => {
    const postData = {
      token: get_token(),
      mcd: login.mcd,
      cid: login.cid,
      level: login.level,
      seq: seq,
    }
    let result = await axios.post(configState.api + '/gympass_admin/gift_one', postData);
    if (result.data.success === 1) {
      setData({ //2
        state: result.data.row.state,
        amount: result.data.row.amount,
        gname: result.data.row.gname,
        mname: result.data.row.mname,
        pdate: result.data.row.pdate,
        regdate: result.data.row.regdate,
        opt: result.data.row.opt,
      })
    }
  }

  const handleChange = e => {
    setData(state => {
      let newState = state;
      newState[e.target.name] = e.target.value;
      return { ...newState };
    });
  }

  useEffect(() => {
    if (openEdit) {
      load_data1();
    }
  }, [openEdit]);

  const onCalendarChange = date => {
    const e = {
      target: {
        name: 'pdate',
        value: moment(date).format('YYYY-MM-DD')
      }
    }
    handleChange(e);
  }

  return <>

    <Dialog
      open={openEdit}
      fullWidth={true}
      maxWidth="sm"
      TransitionComponent={Transition}
      onClose={() => setOpenEdit(false)}
    >

      <AppBar sx={{ position: "static" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography style={{ fontSize: 18 }}>{title}내역 수정</Typography>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpenEdit(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 1, mt: 2 }}>

        <Box display="flex">
          <Box>고객명 : </Box>
          <Box marginLeft={1}>{data.mname}</Box>
        </Box>

        <Box display="flex">
          <Box>사은품명 : </Box>
          <Box marginLeft={1}>{data.gname}</Box>
        </Box>

        <Box display="flex">
          <Box>신철일 : </Box>
          <Box marginLeft={1}>{data.regdate}</Box>
        </Box>

        <Box sx={{ mt: 2 }}>
          <FormControl sx={{ width: 260 }} size="small">
            <InputLabel>사은품</InputLabel>
            <Select
              name="amount"
              label="사은품"
              onChange={handleChange}
              value={data.amount}
            >
              {gift.map((item, index) => {
                return <MenuItem value={item.count} key={index}>{item.title1} :: {item.title2}</MenuItem>
              })}
            </Select>
          </FormControl>
        </Box>

        <Box>
          <FormControl
            fullWidth
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="opt"
              label="옵션"
              size="small"
              autoComplete="off"
              value={data.opt}
              sx={{ width: 360 }}
              onChange={handleChange}
            ></TextField>
          </FormControl>
        </Box>

        <Box marginTop={1}>
          <FormControl sx={{ width: 260 }} size="small">
            <InputLabel>상태</InputLabel>
            <Select
              name="state"
              label="상태"
              onChange={handleChange}
              value={data.state}
            >
              <MenuItem value="발급">발급</MenuItem>
              <MenuItem value="완료">완료</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {data.state === '발송' ?
          <Box sx={{ mt: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <DatePicker
                allowSameDateSelection={true}
                value={data.pdate}
                label="발송일자"
                renderInput={(params) => <TextField size="small" {...params} />}
                onChange={onCalendarChange}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box> : null}
      </Box>

      <Box>
        <Box
          sx={{
            mt: 2, mb: 3, textAlign: "center"
          }}
        >
          <Button variant="contained" onClick={() => onSubmit()} sx={{ ml: 1 }}>
            수정완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => setOpenEdit(false)}
          >
            취소
          </Button>
        </Box>
      </Box>

    </Dialog >
  </>

}

export default ReturnEdit;